module.exports = __webpack_public_path__ + "static/media/house-leave.8eb6820e.svg";